/**
 * @type {import('next-i18next').UserConfig}
 */
module.exports = {
  debug: false,
  serializeConfig: false,
  i18n: {
    defaultLocale: process.env.NEXT_PUBLIC_DEFAULT_LOCALE || 'pl',
    locales: ['cs', 'en', 'lv', 'pl', 'ru'],
    localeDetection: false,
  },
};
